import { render, staticRenderFns } from "./admin-bonus.vue?vue&type=template&id=636a6940&"
import script from "./admin-bonus.vue?vue&type=script&lang=js&"
export * from "./admin-bonus.vue?vue&type=script&lang=js&"
import style0 from "./admin-bonus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports